Cobalt.NavigationItem = function (settings) {
    this.parent = settings.parent;
    this.children = [];
    this.element = settings.element;    
    this.ordinal = this.element.find("div.drag-handle>input.j-ordinal").val();
    this.element.data("navigation-item", this);
};

Cobalt.NavigationItem.prototype =
{
    ordinal: null,
    parent: null, // A pointer back to the parent navigation item.
    element: null, // The HTML element representing this block,    
    setParentOrdinal: function (val) {
        //$.log("Setting parent ordinal to: " + val);
        this.element.find("input#field-" + this.ordinal + "-parent-ordinal").val(val);
    },   
    setDisplayOrder: function (val) {
        //$.log("Setting display ordinal to: " + val);
        $("input#field-" + this.ordinal + "-display-order").val(val);
    },
    remove: function () {
        if (this.parent) {
            this.parent._removeItem(this);
        }
        this.element.remove();
    },
    _removeItem: function (navItem) {
        this.children.splice(this.children.indexOf(navItem), 1); // Remove it from the array         
    },
    addItem: function (li, isExisting) {
        var navItem = new Cobalt.NavigationItem({ "parent": this, "element": li });
        this.children.push(navItem);
        // Place the element
        if (!isExisting) {
            this.element.append(li);
        }
        return navItem;
    },
    pushItem: function (navItem) {
        this.children.push(navItem);
    },
    moveTo: function (newParent) {
        
        if (this.parent) {
            this.parent._removeItem(this);
        }

        if (newParent != null) 
        {
            newParent.pushItem(this);
            this.parent = newParent;
            this.setParentOrdinal(newParent.ordinal);
        }
        else 
        {
            this.setParentOrdinal(0);
        }
        $.log("Moved!");
    }

}


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.NavigationItem.js